/* InFlair PDP (Shopify): assets/inflair-pdp.js
   The <script> of pdp-template 2/index.html, minus two modules whose markup is not in the Shopify section:
   - p01-header (the page's own header preview; the Shopify page has no header markup),
   - p13-buy-offer (bundle cards / Subscribe & Save / cart stub; replaced by the Kaching Bundles app block and the
     theme's product-form.js).
   Changes: the page modules (gallery, sticky bar, below-the-buy-box, videos, reviews, FAQ) are each a function of a
   scope element (document, or the re-rendered section in the theme editor) and run in their own try/catch, so one
   failing module never stops the others; p14-sticky clicks the theme product form's submit button (not while it is
   disabled or busy). Anything that touches the cart is a web component instead, the way assets/product-form-v23.js
   owns add to cart: p16-buy-now is <ifp-buy-now> and owns the whole Buy it now flow (see its comment). */
(function () {
  'use strict';
  if (window.__ifpPdpLoaded) return;
  window.__ifpPdpLoaded = true;

  var MODULES = [];

  /* ===== p10-kaching-subtitles (Shopify only) =====
     The theme's global.js rewrites Kaching's own subtitle copy on every page that has a <product-info> element:
     each .kaching-bundles__bar-subtitle becomes "$14.00 Per Bottle", and .kaching-bundles__subscriptions__subtitle
     becomes "Delivered every 90 days". This page shows what the Kaching app is set to show instead ("2 Serums +
     Bio-Collagen Cream  You save $168.00 + Free Shipping!", "No commitment | Price locked in | Skip or cancel
     anytime"), and global.js is shared with the v18 / v21 / v24 pages that still want those rewrites, so the block
     lives here, in this page's own script.

     How: the textContent / innerText setters drop exactly those two generated strings, and only on the two subtitle
     elements. Every other value - including each one Kaching writes itself - goes straight to the native setter, so
     Kaching stays in charge of the copy, nothing is restored after the fact and there is no flicker or write loop
     (global.js re-reads the element, sees its own string missing, writes again, and the write is dropped again).
     Runs as the file loads, not on DOMContentLoaded, so it is in place before the Kaching app block renders.

     Note: this matches on the text, so a Kaching subtitle literally set to "Delivered every 30 days" or ending in
     "Per Bottle" would be dropped here too. Change the patterns below if that copy is ever wanted. */
  (function () {
    var BAR_SUBTITLE = 'kaching-bundles__bar-subtitle';
    var SUBSCRIPTION_SUBTITLE = 'kaching-bundles__subscriptions__subtitle';

    /* exactly what global.js generates: "<money> Per Bottle" (any currency format) and "Delivered every <n> days" */
    var GENERATED = [
      /^[^\d]*[\d.,]+[^\d]*\s+Per Bottle$/i,
      /^Delivered every \d+ days?$/i
    ];

    function isGenerated(el, value) {
      var classes = el && el.classList;
      if (!classes) return false;
      if (!classes.contains(BAR_SUBTITLE) && !classes.contains(SUBSCRIPTION_SUBTITLE)) return false;

      var text = (value == null ? '' : String(value)).trim();
      for (var i = 0; i < GENERATED.length; i++) {
        if (GENERATED[i].test(text)) return true;
      }
      return false;
    }

    function guard(proto, prop) {
      var desc = proto && Object.getOwnPropertyDescriptor(proto, prop);
      if (!desc || !desc.set || desc.set.ifpGuarded) return;

      var nativeSet = desc.set;
      var guardedSet = function (value) {
        if (isGenerated(this, value)) return;
        nativeSet.call(this, value);
      };
      guardedSet.ifpGuarded = true;

      Object.defineProperty(proto, prop, {
        configurable: true,
        enumerable: desc.enumerable,
        get: desc.get,
        set: guardedSet
      });
    }

    try {
      guard(window.Node && Node.prototype, 'textContent');          /* global.js writes the deal subtitle this way */
      guard(window.HTMLElement && HTMLElement.prototype, 'innerText'); /* ...and the subscription subtitle this way */
    } catch (err) {
      if (window.console && console.error) console.error('[inflair-pdp]', err);
    }
  })();

  /* ===== p11-gallery ===== */
  /* ===== p11-gallery: looping main slider + synced thumbnail strip ===== */
  MODULES.push(function (scope) {
    'use strict';

    var roots = scope.querySelectorAll('[data-ifp-gal]');
    if (!roots.length) return;

    var motionQuery = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
    function reducedMotion() { return !!(motionQuery && motionQuery.matches); }

    function toArray(list) { return Array.prototype.slice.call(list || []); }

    function initGallery(root) {
      var viewport = root.querySelector('[data-ifp-gal-viewport]');
      var track = root.querySelector('[data-ifp-gal-track]');
      if (!viewport || !track) return;

      var slides = toArray(track.querySelectorAll('[data-ifp-gal-slide]'));
      var count = slides.length;
      if (!count) return;

      var status = root.querySelector('[data-ifp-gal-status]');
      var thumbsViewport = root.querySelector('[data-ifp-gal-thumbs]');
      var thumbsTrack = root.querySelector('[data-ifp-gal-thumbs-track]');
      var thumbs = toArray(root.querySelectorAll('[data-ifp-gal-thumb]'));
      var prevBtn = root.querySelector('[data-ifp-gal-prev]');
      var nextBtn = root.querySelector('[data-ifp-gal-next]');

      var loop = count > 1;
      var index = 0;                 // logical slide (0..count-1)
      var pos = loop ? 1 : 0;        // physical position in the track (includes the leading clone)
      var wrapTimer = null;

      /* --- clones at both ends for a seamless loop --- */
      function makeClone(slide) {
        var c = slide.cloneNode(true);
        c.removeAttribute('data-ifp-gal-slide');
        c.removeAttribute('role');
        c.removeAttribute('aria-roledescription');
        c.removeAttribute('aria-label');
        c.setAttribute('aria-hidden', 'true');
        c.setAttribute('data-ifp-gal-clone', '');
        toArray(c.querySelectorAll('[id]')).forEach(function (el) { el.removeAttribute('id'); });
        toArray(c.querySelectorAll('img')).forEach(function (img) { img.setAttribute('alt', ''); });
        toArray(c.querySelectorAll('[role="img"]')).forEach(function (el) {
          el.removeAttribute('role');
          el.removeAttribute('aria-label');
        });
        return c;
      }
      // The leading clone is only shown while it can be on screen (moving/dragging back from slide 1),
      // so at rest nothing sits to the left of the active slide (as in the reference).
      var leadClone = null;
      function setLeadVisible(on) { if (leadClone) leadClone.style.visibility = on ? '' : 'hidden'; }
      if (loop) {
        leadClone = makeClone(slides[count - 1]);
        track.insertBefore(leadClone, track.firstChild);
        track.appendChild(makeClone(slides[0]));
        setLeadVisible(false);
      }

      /* --- looping thumbnail strip: one clone of the last thumb before the first, a full set of clones
         after the last, so the active thumb always sits at the start of the strip (as in the reference). --- */
      var thumbLoop = loop && !!thumbsTrack && thumbs.length === count;
      var thumbSlots = thumbs.slice();     // physical order in the strip; slot index === main-track pos
      var thumbClones = [];                // [{el, src}]
      function makeThumbClone(thumb, src) {
        var c = thumb.cloneNode(true);
        c.removeAttribute('data-ifp-gal-thumb');
        c.removeAttribute('aria-current');
        c.removeAttribute('aria-label');
        c.setAttribute('aria-hidden', 'true');
        c.setAttribute('tabindex', '-1');
        c.setAttribute('data-ifp-gal-thumb-clone', '');
        c.classList.remove('is-active');
        c.addEventListener('click', function () { goTo(src); });
        thumbClones.push({ el: c, src: src });
        return c;
      }
      if (thumbLoop) {
        var lead = makeThumbClone(thumbs[count - 1], count - 1);
        thumbsTrack.insertBefore(lead, thumbsTrack.firstChild);
        var trail = thumbs.map(function (t, i) { return makeThumbClone(t, i); });
        trail.forEach(function (c) { thumbsTrack.appendChild(c); });
        thumbSlots = [lead].concat(thumbs, trail);
      }

      /* --- positioning --- */
      function applyTrack(animate, dragPx) {
        var anim = animate && !reducedMotion();
        if (pos === 0 || (pos === 1 && dragPx > 0)) setLeadVisible(true);
        else if (!anim) setLeadVisible(false); // animated moves hide it on transitionend
        track.style.transition = anim ? '' : 'none';
        var offset = 'calc(' + (-pos) + ' * (100% + var(--ifp-gal-gap, 0px))' +
          (dragPx ? ' + ' + Math.round(dragPx) + 'px' : '') + ')';
        track.style.transform = 'translate3d(' + offset + ', 0, 0)';
      }

      // Current rendered translateX of an element in px (mid-transition value while animating).
      function currentPx(el) {
        var t = window.getComputedStyle(el || track).transform;
        var m = t && t.match(/matrix(3d)?\(([^)]+)\)/);
        if (!m) return 0;
        var v = m[2].split(',');
        return parseFloat(m[1] ? v[12] : v[4]) || 0;
      }

      // If the track sits on a clone, jump (without animation) to the matching real slide.
      // keepVisual: when a move interrupts the animation onto a clone (rapid clicks at the loop
      // boundary), shift from the current mid-animation spot instead of snapping, so the next
      // transition continues smoothly.
      function normalize(keepVisual) {
        var inFlight = wrapTimer !== null;
        if (wrapTimer) { clearTimeout(wrapTimer); wrapTimer = null; }
        if (!loop) return;
        var shift;
        if (pos === 0) shift = count;
        else if (pos === count + 1) shift = -count;
        else return;
        var oldPos = pos;
        pos += shift;
        if (keepVisual === true && inFlight && !reducedMotion()) {
          var gap = parseFloat(window.getComputedStyle(track).columnGap) || 0;
          var px = currentPx() - shift * (track.offsetWidth + gap);
          track.style.transition = 'none';
          track.style.transform = 'translate3d(' + px + 'px, 0, 0)';
          if (thumbLoop) {
            var d = slotLeft(pos) - slotLeft(oldPos);
            thumbX = slotLeft(pos);
            thumbsTrack.style.transition = 'none';
            thumbsTrack.style.transform = 'translate3d(' + (currentPx(thumbsTrack) - d) + 'px, 0, 0)';
          }
        } else {
          applyTrack(false);
          if (thumbLoop) setThumbX(slotLeft(pos), false);
        }
        void track.offsetWidth; // flush so the next transition starts from here
        if (thumbLoop) void thumbsTrack.offsetWidth;
      }

      function scheduleWrap() {
        if (!loop || (pos !== 0 && pos !== count + 1)) return;
        if (reducedMotion()) { normalize(); return; }
        if (wrapTimer) clearTimeout(wrapTimer);
        wrapTimer = setTimeout(normalize, 450); // fallback if transitionend never fires
      }

      track.addEventListener('transitionend', function (e) {
        if (e.target !== track || e.propertyName !== 'transform') return;
        normalize();
        if (pos !== 0) setLeadVisible(false);
      });

      /* --- thumbnails --- */
      var thumbX = 0;                // current strip offset (px)

      function thumbMax() {
        var last = thumbSlots[thumbSlots.length - 1];
        return Math.max(0, last.offsetLeft + last.offsetWidth - thumbsViewport.clientWidth);
      }

      // Left edge of a strip slot (thumbs track is the offsetParent: position:relative).
      function slotLeft(p) {
        var el = thumbSlots[Math.min(Math.max(p, 0), thumbSlots.length - 1)];
        return el ? el.offsetLeft : 0;
      }

      function setThumbX(x, animate) {
        thumbX = Math.min(Math.max(x, 0), thumbMax());
        thumbsTrack.style.transition = (animate && !reducedMotion()) ? '' : 'none';
        thumbsTrack.style.transform = 'translate3d(' + (-thumbX) + 'px, 0, 0)';
      }

      // Active thumb aligned to the start of the strip. Looping strip: follows the main track's physical
      // position (so it wraps through the clones); otherwise clamped so the strip never over-scrolls.
      function syncThumbs(animate) {
        if (!thumbsViewport || !thumbsTrack || !thumbs.length) return;
        if (thumbLoop) { setThumbX(slotLeft(pos), animate); return; }
        var active = thumbs[index] || thumbs[0];
        setThumbX(active.offsetLeft, animate);
      }

      // Keyboard (Tab) focus on a clipped thumb: shift the strip just enough to show it.
      function revealThumb(thumb) {
        if (!thumbsViewport || !thumbsTrack) return;
        var visible = false;
        try { visible = thumb.matches(':focus-visible'); } catch (err) { visible = false; }
        if (!visible) return; // mouse/touch focus: leave the strip alone so the click lands where pressed
        var left = thumb.offsetLeft;
        var right = left + thumb.offsetWidth;
        var width = thumbsViewport.clientWidth;
        if (left < thumbX) setThumbX(left, true);
        else if (right > thumbX + width) setThumbX(right - width, true);
      }

      function render(animateThumbs) {
        slides.forEach(function (slide, i) {
          slide.setAttribute('aria-hidden', i === index ? 'false' : 'true');
        });
        thumbs.forEach(function (thumb, i) {
          var on = i === index;
          thumb.classList.toggle('is-active', on);
          if (on) thumb.setAttribute('aria-current', 'true');
          else thumb.removeAttribute('aria-current');
        });
        thumbClones.forEach(function (c) { c.el.classList.toggle('is-active', c.src === index); });
        if (status) status.textContent = 'Slide ' + (index + 1) + ' of ' + count;
        syncThumbs(animateThumbs);
      }

      /* --- navigation --- */
      function step(dir) {
        if (count < 2) return;
        normalize(true);
        index = (index + dir + count) % count;
        pos = loop ? pos + dir : index;
        applyTrack(true);
        scheduleWrap();
        render(true);
      }
      function next() { step(1); }
      function prev() { step(-1); }

      function goTo(i) {
        if (i < 0 || i >= count) return;
        normalize(true);
        if (i === index) { applyTrack(true); return; }
        index = i;
        pos = loop ? i + 1 : i;
        applyTrack(true);
        render(true);
      }

      if (prevBtn) prevBtn.addEventListener('click', prev);
      if (nextBtn) nextBtn.addEventListener('click', next);

      thumbs.forEach(function (thumb, i) {
        thumb.addEventListener('click', function () { goTo(i); });
        thumb.addEventListener('focus', function () { revealThumb(thumb); });
      });

      // Positioning is transform-based: undo any native scroll of the clipped viewports
      // (focus / find-in-page in browsers that fall back from overflow:clip to hidden).
      [viewport, thumbsViewport].forEach(function (el) {
        if (!el) return;
        el.addEventListener('scroll', function () { if (el.scrollLeft) el.scrollLeft = 0; });
      });

      root.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
        var t = e.target;
        if (!t || (t.tagName !== 'BUTTON' && t !== viewport)) return;
        e.preventDefault();
        var dir = e.key === 'ArrowLeft' ? -1 : 1;
        var ti = thumbs.indexOf(t);
        // On a thumb, move relative to the focused thumb (Tab may have moved focus off the active one).
        if (ti !== -1 && ti !== index) goTo((ti + dir + count) % count);
        else step(dir);
        if (ti !== -1 && thumbs[index]) thumbs[index].focus({ preventScroll: true });
      });

      /* --- swipe / drag on the main slider --- */
      var drag = null;

      viewport.addEventListener('pointerdown', function (e) {
        if (count < 2) return;
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        normalize();
        drag = {
          id: e.pointerId,
          x: e.clientX,
          y: e.clientY,
          dx: 0,
          t: Date.now(),
          width: viewport.clientWidth || 1,
          active: false
        };
      });

      viewport.addEventListener('pointermove', function (e) {
        if (!drag || e.pointerId !== drag.id) return;
        var dx = e.clientX - drag.x;
        var dy = e.clientY - drag.y;
        if (!drag.active) {
          if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
          if (Math.abs(dy) > Math.abs(dx)) { drag = null; return; } // vertical scroll wins
          drag.active = true;
          drag.x = e.clientX; // start from here so the slide doesn't jump by the threshold
          dx = 0;
          drag.t = Date.now();
          root.classList.add('is-dragging');
          try { viewport.setPointerCapture(e.pointerId); } catch (err) { /* ignore */ }
        }
        e.preventDefault();
        drag.dx = dx;
        applyTrack(false, dx);
      });

      function endDrag(e) {
        if (!drag || e.pointerId !== drag.id) return;
        var d = drag;
        drag = null;
        root.classList.remove('is-dragging');
        try { viewport.releasePointerCapture(e.pointerId); } catch (err) { /* ignore */ }
        if (!d.active) return;
        var elapsed = Math.max(1, Date.now() - d.t);
        var velocity = d.dx / elapsed; // px per ms
        var threshold = d.width * 0.18;
        if (e.type !== 'pointercancel' && (d.dx <= -threshold || (velocity < -0.45 && d.dx < -30))) next();
        else if (e.type !== 'pointercancel' && (d.dx >= threshold || (velocity > 0.45 && d.dx > 30))) prev();
        else applyTrack(true);
      }
      viewport.addEventListener('pointerup', endDrag);
      viewport.addEventListener('pointercancel', endDrag);
      // Only the viewport's own capture loss ends a drag. Touch pointers are implicitly captured by the
      // element under the finger; moving capture to the viewport fires (and bubbles) lostpointercapture
      // from that child, which must not cancel the swipe that just started.
      viewport.addEventListener('lostpointercapture', function (e) {
        if (e.target === viewport && drag && drag.active && e.pointerId === drag.id) endDrag(e);
      });
      viewport.addEventListener('dragstart', function (e) { e.preventDefault(); });

      /* --- keep thumbs aligned across breakpoint changes --- */
      var resizeTimer = null;
      window.addEventListener('resize', function () {
        if (resizeTimer) clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () { syncThumbs(false); }, 80);
      });

      applyTrack(false);
      render(false);
    }

    toArray(roots).forEach(initGallery);
  });

  /* ===== p13-kb-display (Shopify only) ===== */
  /* The two things this page adds to Kaching's bundle bars, both redrawn whenever Kaching rebuilds them:

     - the savings badge under the price ("You save 68%"), as on the static page. The copy is typed per bundle in
       the section settings and handed over on the wrap as data-ifp-save-1 / -2 / -3, in the order Kaching lists
       the bundles - nothing is worked out from the prices, so the badge says exactly what the merchant wrote. The
       badge is the static page's own markup, so assets/inflair-pdp.css already styles it (.ifp-bo-pill).

     - a line break in the subtitle, in front of the phrase in data-ifp-subtitle-break ("You save" by default), so
       "3 Serums + 2 Bio-Collagen Creams  You save $246.00 + Free Shipping!" reads as two lines. The break is a
       newline written into Kaching's own text node, not markup: the node keeps its place, so Kaching can carry on
       patching the subtitle, and the CSS rule for .kaching-bundles__bar-subtitle (white-space: pre-line) is what
       renders it. A subtitle that already starts with the phrase is left alone - there is nothing to put above it. */
  MODULES.push(function (scope) {
    'use strict';

    var tabs = scope.querySelector('ifp-kb-tabs') || document.querySelector('ifp-kb-tabs');
    if (!tabs) return;

    var PILL_MARK = 'data-ifp-save-pill';
    var breakBefore = (tabs.getAttribute('data-ifp-subtitle-break') || '').trim();

    /* -- savings badge ---------------------------------------------------- */

    function renderBadges(wrap, columns) {
      columns.forEach(function (pricing, index) {
        var copy = wrap.getAttribute('data-ifp-save-' + (index + 1));
        var pill = pricing.querySelector('[' + PILL_MARK + ']');

        if (!copy) {
          if (pill) pill.remove();
          return;
        }

        if (!pill) {
          pill = document.createElement('span');
          pill.className = 'ifp-bo-pill';
          pill.setAttribute(PILL_MARK, '');
          pill.appendChild(document.createElement('span')).className = 'ifp-bo-pill-t';
          pricing.appendChild(pill);
        }

        var target = pill.firstChild;
        if (target.textContent !== copy) target.textContent = copy;
      });
    }

    /* -- subtitle line break ---------------------------------------------- */

    function textNodes(el) {
      var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
      var nodes = [];
      var node;
      while ((node = walker.nextNode())) nodes.push(node);
      return nodes;
    }

    function breakSubtitle(subtitle) {
      var nodes = textNodes(subtitle);
      var full = nodes.map(function (node) { return node.nodeValue; }).join('');
      var at = full.toLowerCase().indexOf(breakBefore.toLowerCase());

      /* nothing in front of the phrase (or a line break already there): leave Kaching's text as it is */
      if (at <= 0 || full.charAt(at - 1) === '\n') return;

      var offset = 0;
      for (var i = 0; i < nodes.length; i++) {
        var value = nodes[i].nodeValue;
        if (at < offset + value.length) {
          var cut = at - offset;
          nodes[i].nodeValue = value.slice(0, cut).replace(/[^\S\n]+$/, '') + '\n' + value.slice(cut);
          return;
        }
        offset += value.length;
      }
    }

    /* -- both, over every bar --------------------------------------------- */

    function render() {
      Array.prototype.forEach.call(tabs.querySelectorAll('.ifp-kb-wrap'), function (wrap) {
        /* the Subscribe & Save row is a tab control here, not a bundle, so it is not counted or badged */
        var columns = Array.prototype.filter.call(
          wrap.querySelectorAll('.kaching-bundles__bar-pricing'),
          function (pricing) { return !pricing.closest('.kaching-bundles__subscriptions'); }
        );
        renderBadges(wrap, columns);

        if (!breakBefore) return;
        Array.prototype.forEach.call(wrap.querySelectorAll('.kaching-bundles__bar-subtitle'), breakSubtitle);
      });
    }

    var pending = null;
    var observer = new MutationObserver(function () {
      clearTimeout(pending);
      pending = setTimeout(render, 60);
    });
    observer.observe(tabs, { childList: true, subtree: true, characterData: true });

    document.addEventListener('ifp:kb-switch', render);
    render();
  });

  /* ===== p14-sticky ===== */
  /* p14 sticky ATC bar: visible once the main ADD TO CART button has scrolled above the viewport; clicks trigger it.
     Shopify: the main button is the theme product form's .product-form__submit, so the bar runs the same theme / Kaching
     add to cart (adds the selected bundle and opens the cart drawer, as on v18 / v24). It does nothing while that button
     is missing, sold out (disabled) or busy (aria-disabled while adding); when sold out it renders disabled itself. */
  MODULES.push(function (scope) {
    'use strict';
    var bars = scope.querySelectorAll('.ifp-stk');
    if (!bars.length) return;

    /* With two Kaching widgets the buy box has one form per widget and only the visible one may add, so the bar
       follows the button of the wrap on screen (<ifp-kb-tabs>, p12). */
    function mainAtc() {
      var all = scope.querySelectorAll('product-form .product-form__submit');
      for (var i = 0; i < all.length; i++) {
        if (!all[i].closest('.ifp-stk') && !all[i].closest('[hidden]')) return all[i];
      }
      return null;
    }

    /* product-form.js marks the main button .loading (and aria-disabled) for exactly as long as it is adding. */
    function isAdding(atc) {
      return !!atc && (atc.classList.contains('loading') || atc.getAttribute('aria-disabled') === 'true');
    }

    Array.prototype.forEach.call(bars, function (bar) {
      var btn = bar.querySelector('[data-ifp-stk-atc]');
      var target = mainAtc();

      function show(on) { bar.classList.toggle('is-shown', on); }

      /* The bar's button is the main one at a distance, so it carries the same spinner while that add runs. */
      var busyObserver = new MutationObserver(syncBusy);
      function syncBusy() {
        if (btn) btn.classList.toggle('is-loading', isAdding(mainAtc()));
      }
      function watchBusy(atc) {
        busyObserver.disconnect();
        if (atc) busyObserver.observe(atc, { attributes: true, attributeFilter: ['class', 'aria-disabled'] });
        syncBusy();
      }
      watchBusy(target);

      if (btn) {
        btn.addEventListener('click', function () {
          /* Buy it now owns the cart while its body class is on, and the bar presses the main button through code,
             which the swallow guard in <ifp-buy-now> lets through - so the bar stands down here instead. */
          if (document.body.classList.contains('ifp-buynow')) return;

          var atc = mainAtc();
          if (!atc || atc.disabled || atc.getAttribute('aria-disabled') === 'true') return;
          atc.click();
        });
      }

      if (!target) return; /* no main ATC on the page: keep the bar hidden */

      if (!('IntersectionObserver' in window)) {
        show(true);
        return;
      }
      /* Show only once the shopper has scrolled past the main button (it is above the viewport),
         so the bar never covers the bundle cards or the Subscribe & Save box on first load. */
      var io = new IntersectionObserver(function (entries) {
        var entry = entries[entries.length - 1];
        show(!entry.isIntersecting && entry.boundingClientRect.top < 0);
      });
      io.observe(target);

      /* the wrap that was being watched is hidden now: watch the button of the one that took its place */
      document.addEventListener('ifp:kb-switch', function () {
        var next = mainAtc();
        if (!next || next === target) return;
        io.unobserve(target);
        target = next;
        io.observe(target);
        watchBusy(target);
      });
    });
  });

  /* ===== p15-below ===== */
  /* p15-below: delivery-date estimate + FAQ accordion (independent toggles) */
  MODULES.push(function (scope) {
    'use strict';
    var roots = scope.querySelectorAll('[data-ifp-blw]');
    if (!roots.length) return;

    var DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July',
      'August', 'September', 'October', 'November', 'December'];

    function ordinal(n) {
      var m100 = n % 100;
      if (m100 >= 11 && m100 <= 13) return n + 'th';
      switch (n % 10) {
        case 1: return n + 'st';
        case 2: return n + 'nd';
        case 3: return n + 'rd';
        default: return n + 'th';
      }
    }

    // "Thursday, October 15th" for today + offset days (local time)
    function formatOffset(offset) {
      var d = new Date();
      d.setHours(12, 0, 0, 0);
      d.setDate(d.getDate() + offset);
      return DAYS[d.getDay()] + ', ' + MONTHS[d.getMonth()] + ' ' + ordinal(d.getDate());
    }

    function reducedMotion() {
      return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    }

    function setupAccordionItem(item) {
      var btn = item.querySelector('.ifp-blw-faq-btn');
      var panel = item.querySelector('.ifp-blw-faq-panel');
      if (!btn || !panel) return;
      var timer = null;

      function finish(open) {
        if (timer) { clearTimeout(timer); timer = null; }
        panel.removeEventListener('transitionend', onEnd);
        panel.style.height = '';
        if (!open) panel.hidden = true;
      }
      function onEnd(e) {
        if (e && e.target !== panel) return;
        finish(btn.getAttribute('aria-expanded') === 'true');
      }

      function toggle(open) {
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        item.setAttribute('data-state', open ? 'open' : 'closed');
        panel.removeEventListener('transitionend', onEnd);
        if (timer) { clearTimeout(timer); timer = null; }

        if (reducedMotion()) {
          panel.style.height = '';
          panel.hidden = !open;
          return;
        }

        var start;
        if (open) {
          start = panel.hidden ? 0 : panel.getBoundingClientRect().height;
          panel.hidden = false;
          panel.style.height = start + 'px';
          void panel.offsetHeight; // commit start height
          panel.style.height = panel.scrollHeight + 'px';
        } else {
          start = panel.getBoundingClientRect().height;
          panel.style.height = start + 'px';
          void panel.offsetHeight;
          panel.style.height = '0px';
        }
        panel.addEventListener('transitionend', onEnd);
        timer = setTimeout(function () { finish(open); }, 320); // fallback if transitionend never fires
      }

      item.setAttribute('data-state', 'closed');
      btn.addEventListener('click', function () {
        toggle(btn.getAttribute('aria-expanded') !== 'true');
      });
    }

    Array.prototype.forEach.call(roots, function (root) {
      // Delivery estimate
      var dates = root.querySelectorAll('[data-ifp-blw-date]');
      Array.prototype.forEach.call(dates, function (el) {
        var off = parseInt(el.getAttribute('data-ifp-blw-date'), 10);
        if (!isNaN(off)) el.textContent = formatOffset(off);
      });

      // FAQ accordion
      var items = root.querySelectorAll('[data-ifp-blw-acc]');
      Array.prototype.forEach.call(items, setupAccordionItem);
    });
  });

  /* ===== p30-glow ===== */
  /* p30-glow: looping UGC video carousel (arrows, dots, drag/swipe, keyboard) + play/pause toggle */
  MODULES.push(function (scope) {
    'use strict';
    var roots = scope.querySelectorAll('[data-ifp-glow]');
    if (!roots.length) return;

    var reduceMQ = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
    function reducedMotion() { return !!(reduceMQ && reduceMQ.matches); }
    var DURATION = 250; // reference: transform 250ms ease

    Array.prototype.forEach.call(roots, function (root) {
      try { init(root); } catch (err) { /* never break the page */ }
    });

    function init(root) {
      var viewport = root.querySelector('[data-ifp-glow-viewport]');
      var track = root.querySelector('[data-ifp-glow-track]');
      if (!viewport || !track) return;
      var originals = Array.prototype.slice.call(track.querySelectorAll('[data-ifp-glow-slide]'));
      var N = originals.length;
      if (!N) return;

      var prevBtn = root.querySelector('[data-ifp-glow-prev]');
      var nextBtn = root.querySelector('[data-ifp-glow-next]');
      var dots = Array.prototype.slice.call(root.querySelectorAll('[data-ifp-glow-dot]'));
      var status = root.querySelector('[data-ifp-glow-status]');

      originals.forEach(function (s, i) { s.setAttribute('data-ifp-glow-src', String(i)); });

      // Loop: one full set of clones before and after the real slides.
      function makeClone(s) {
        var c = s.cloneNode(true);
        c.setAttribute('data-ifp-glow-clone', '');
        c.setAttribute('aria-hidden', 'true');
        Array.prototype.forEach.call(c.querySelectorAll('[id]'), function (el) { el.removeAttribute('id'); });
        Array.prototype.forEach.call(c.querySelectorAll('button, a, video, [tabindex]'), function (el) {
          el.setAttribute('tabindex', '-1');
          if (el.tagName === 'VIDEO') { el.preload = 'none'; el.removeAttribute('autoplay'); }
        });
        return c;
      }
      var before = document.createDocumentFragment();
      var after = document.createDocumentFragment();
      originals.forEach(function (s) {
        before.appendChild(makeClone(s));
        after.appendChild(makeClone(s));
      });
      track.insertBefore(before, track.firstChild);
      track.appendChild(after);
      var all = Array.prototype.slice.call(track.querySelectorAll('[data-ifp-glow-slide]'));

      var index = 0;      // logical start slide; may sit in [-N, 2N) while animating over clones
      var settleTimer = 0;
      var lastDragEnd = 0;

      function mod(i) { return ((i % N) + N) % N; }
      function stepPx() {
        var a = all[0].getBoundingClientRect();
        var b = all[1].getBoundingClientRect();
        return b.left - a.left;
      }
      function perView() {
        var v = parseFloat(getComputedStyle(root).getPropertyValue('--ifp-glow-spp'));
        return v > 0 ? v : 1;
      }
      function baseX() { return -(index + N) * stepPx(); }
      function setX(x, animate) {
        track.style.transition = animate ? 'transform ' + DURATION + 'ms ease' : 'none';
        track.style.transform = 'translate3d(' + x + 'px,0,0)';
      }

      function updateUi() {
        var n = mod(index);
        dots.forEach(function (d, i) {
          var on = i === n;
          d.classList.toggle('is-active', on);
          d.setAttribute('aria-current', on ? 'true' : 'false');
        });
        if (status) status.textContent = 'Slide ' + (n + 1) + ' of ' + N;
      }

      // Jump (without animation) from a clone position to the equivalent real position.
      function normalize() {
        clearTimeout(settleTimer);
        var n = mod(index);
        if (n === index) return;
        index = n;
        setX(baseX(), false);
        void track.offsetWidth; // commit the jump before any new transition starts
        handOffPlayback();
      }

      function goTo(target, animate) {
        clearTimeout(settleTimer);
        index = target;
        var anim = animate !== false && !reducedMotion();
        setX(baseX(), anim);
        updateUi();
        if (anim) settleTimer = setTimeout(normalize, DURATION + 40);
        else normalize();
      }

      function move(delta) {
        var target = index + delta;
        // stay inside the cloned range; otherwise normalize first
        if (target < -N || target + N > 3 * N - Math.ceil(perView())) {
          normalize();
          target = index + delta;
        }
        goTo(target);
      }

      if (prevBtn) prevBtn.addEventListener('click', function () { move(-1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { move(1); });
      dots.forEach(function (d) {
        d.addEventListener('click', function () {
          var k = parseInt(d.getAttribute('data-ifp-glow-dot'), 10) || 0;
          normalize();
          if (k !== index) goTo(k);
        });
      });

      root.addEventListener('keydown', function (e) {
        if (e.defaultPrevented) return;
        var t = e.target;
        if (t && /^(INPUT|TEXTAREA|SELECT)$/.test(t.tagName)) return;
        if (e.key === 'ArrowLeft') { e.preventDefault(); move(-1); }
        else if (e.key === 'ArrowRight') { e.preventDefault(); move(1); }
      });

      // Keyboard focus on an off-screen real slide brings it into view.
      track.addEventListener('focusin', function (e) {
        var slide = e.target.closest ? e.target.closest('[data-ifp-glow-slide]') : null;
        if (!slide || slide.hasAttribute('data-ifp-glow-clone')) return;
        var s = parseInt(slide.getAttribute('data-ifp-glow-src'), 10);
        // Compare REAL positions: when the view wraps (e.g. start 4 of 5), the slot after slide 5
        // shows a clone of slide 1, so the real slide 1 is off-screen even though "1" looks visible.
        normalize();
        var pv = Math.max(1, Math.floor(perView()));
        if (s < index || s >= index + pv) goTo(s);
      });
      viewport.addEventListener('scroll', function () { viewport.scrollLeft = 0; });

      // ----- drag / swipe -----
      var drag = null;
      viewport.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        normalize();
        drag = { id: e.pointerId, x: e.clientX, y: e.clientY, active: false, w: stepPx(), dx: 0 };
      });
      viewport.addEventListener('pointermove', function (e) {
        if (!drag || e.pointerId !== drag.id) return;
        var dx = e.clientX - drag.x;
        var dy = e.clientY - drag.y;
        if (!drag.active) {
          if (Math.abs(dy) > 10 && Math.abs(dy) > Math.abs(dx)) { drag = null; return; }
          if (Math.abs(dx) < 6 || Math.abs(dx) < Math.abs(dy)) return;
          drag.active = true;
          clearTimeout(settleTimer);
          root.classList.add('is-dragging');
          try { viewport.setPointerCapture(e.pointerId); } catch (err) { /* ignore */ }
        }
        var max = Math.ceil(perView()) * drag.w;
        drag.dx = Math.max(-max, Math.min(max, dx));
        setX(baseX() + drag.dx, false);
        if (e.cancelable) e.preventDefault();
      });
      function endDrag(e) {
        if (!drag || e.pointerId !== drag.id) return;
        var d = drag;
        drag = null;
        if (!d.active) return;
        root.classList.remove('is-dragging');
        lastDragEnd = Date.now();
        var steps = 0;
        if (e.type !== 'pointercancel' && d.w > 0) {
          steps = Math.round(-d.dx / d.w);
          if (steps === 0 && Math.abs(d.dx) > 40) steps = d.dx < 0 ? 1 : -1;
        }
        move(steps);
      }
      viewport.addEventListener('pointerup', endDrag);
      viewport.addEventListener('pointercancel', endDrag);
      viewport.addEventListener('dragstart', function (e) { e.preventDefault(); });
      // a drag must not count as a click on a card
      viewport.addEventListener('click', function (e) {
        if (Date.now() - lastDragEnd < 350) { e.preventDefault(); e.stopPropagation(); }
      }, true);

      // ----- play / pause -----
      function videoOf(slide) { return slide.querySelector('video'); }
      function setPlaying(slide, on) {
        slide.classList.toggle('is-playing', on);
        var n = parseInt(slide.getAttribute('data-ifp-glow-src'), 10) + 1;
        var btn = slide.querySelector('[data-ifp-glow-play]');
        if (btn) btn.setAttribute('aria-label', (on ? 'Pause video ' : 'Play video ') + n);
      }
      function toggle(slide) {
        var src = slide.getAttribute('data-ifp-glow-src');
        var on = !slide.classList.contains('is-playing');
        all.forEach(function (s) {
          var same = s.getAttribute('data-ifp-glow-src') === src;
          setPlaying(s, same && on);
          var v = videoOf(s);
          if (!v) return;
          if (same && on && s === slide) {
            var p = v.play();
            if (p && p.catch) p.catch(function () { resetSrc(src); });
          } else if (!v.paused) {
            v.pause();
          }
        });
      }
      // When a clone was playing and we jump to its real twin, carry playback over.
      function handOffPlayback() {
        all.forEach(function (s) {
          if (!s.hasAttribute('data-ifp-glow-clone')) return;
          var v = videoOf(s);
          if (!v || v.paused) return;
          var real = originals[parseInt(s.getAttribute('data-ifp-glow-src'), 10)];
          var rv = real && videoOf(real);
          if (!rv) return;
          try { rv.currentTime = v.currentTime; } catch (err) { /* ignore */ }
          v.pause();
          var p = rv.play();
          if (p && p.catch) p.catch(function () { /* ignore */ });
        });
      }
      track.addEventListener('click', function (e) {
        var media = e.target.closest ? e.target.closest('[data-ifp-glow-media]') : null;
        if (!media) return;
        var slide = media.closest('[data-ifp-glow-slide]');
        if (slide) toggle(slide);
      });
      function resetSrc(src) {
        all.forEach(function (s) { if (s.getAttribute('data-ifp-glow-src') === src) setPlaying(s, false); });
      }
      track.addEventListener('ended', function (e) {
        var slide = e.target.closest ? e.target.closest('[data-ifp-glow-slide]') : null;
        if (slide) resetSrc(slide.getAttribute('data-ifp-glow-src'));
      }, true);

      // ----- layout -----
      var raf = 0;
      function relayout() {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          if (drag && drag.active) return;
          normalize();
          setX(baseX(), false);
        });
      }
      window.addEventListener('resize', relayout);
      if (window.ResizeObserver) new ResizeObserver(relayout).observe(viewport);

      setX(baseX(), false);
      updateUi();
    }
  });

  /* ===== p50-testimonials ===== */
  /* p50-testimonials: infinite review carousel.
     Mirrors the reference carousel: active "page" centred in the viewport (page = --ifp-tst-spp slides),
     a full copy of the slides is cloned on each side for seamless looping, 250ms ease transform.
     Arrows (desktop) / dots (tablet+mobile), swipe/drag, Left/Right keys. No autoplay (the spec has none). */
  MODULES.push(function (scope) {
    'use strict';
    var roots = scope.querySelectorAll('[data-ifp-tst]');
    if (!roots.length) return;

    var mq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
    function reduced() { return !!(mq && mq.matches); }
    var DURATION = 250;

    for (var r = 0; r < roots.length; r++) init(roots[r]);

    function init(root) {
      var viewport = root.querySelector('[data-ifp-tst-viewport]');
      var track = root.querySelector('[data-ifp-tst-track]');
      if (!viewport || !track || track.getAttribute('data-ifp-tst-ready')) return;
      var real = Array.prototype.slice.call(track.querySelectorAll('[data-ifp-tst-slide]'));
      var n = real.length;
      if (!n) return;
      track.setAttribute('data-ifp-tst-ready', '1');

      var prevBtn = root.querySelector('[data-ifp-tst-prev]');
      var nextBtn = root.querySelector('[data-ifp-tst-next]');
      var dots = Array.prototype.slice.call(root.querySelectorAll('[data-ifp-tst-dot]'));
      var live = root.querySelector('[data-ifp-tst-live]');

      /* clones: one full set before and one after the real slides */
      var before = document.createDocumentFragment();
      var after = document.createDocumentFragment();
      real.forEach(function (s) { before.appendChild(makeClone(s)); });
      real.forEach(function (s) { after.appendChild(makeClone(s)); });
      track.insertBefore(before, track.firstChild);
      track.appendChild(after);
      var slides = Array.prototype.slice.call(track.children);

      var pos = n;          /* index into slides; real slide i lives at n + i */
      var current = 0;      /* real index shown */
      var dragDx = 0;
      var settleTimer = null;

      function makeClone(s) {
        var c = s.cloneNode(true);
        c.removeAttribute('data-ifp-tst-slide');
        c.removeAttribute('role');
        c.removeAttribute('aria-roledescription');
        c.removeAttribute('aria-label');
        c.setAttribute('data-ifp-tst-clone', '');
        c.setAttribute('aria-hidden', 'true');
        c.setAttribute('inert', '');
        var ids = c.querySelectorAll('[id]');
        for (var i = 0; i < ids.length; i++) ids[i].removeAttribute('id');
        return c;
      }

      function px(v) { var f = parseFloat(v); return isNaN(f) ? 0 : f; }

      function metrics() {
        var spp = px(getComputedStyle(root).getPropertyValue('--ifp-tst-spp')) || 1;
        var vcs = getComputedStyle(viewport);
        var w = viewport.getBoundingClientRect().width - px(vcs.paddingLeft) - px(vcs.paddingRight);
        var tcs = getComputedStyle(track);
        var gap = px(tcs.columnGap || tcs.gap);
        var sw = slides[0].getBoundingClientRect().width;
        return { spp: spp, w: w, gap: gap, sw: sw };
      }

      function offsetFor(p) {
        var m = metrics();
        var page = m.spp * m.sw + (m.spp - 1) * m.gap;
        return (m.w - page) / 2 - p * (m.sw + m.gap);
      }

      function apply(animate) {
        var x = offsetFor(pos) + dragDx;
        track.style.transition = (animate && !reduced()) ? 'transform ' + DURATION + 'ms ease' : 'none';
        track.style.transform = 'translate3d(' + x + 'px,0,0)';
      }

      function normalize() {
        if (settleTimer) { clearTimeout(settleTimer); settleTimer = null; }
        var norm = n + (((pos - n) % n) + n) % n;
        if (norm !== pos) {
          pos = norm;
          apply(false);
          void track.offsetWidth; /* commit the jump before any new transition */
        }
      }

      function setActive(i, announce) {
        current = i;
        dots.forEach(function (d, k) {
          var on = k === i;
          d.classList.toggle('is-active', on);
          d.setAttribute('aria-current', on ? 'true' : 'false');
        });
        if (announce && live) live.textContent = 'Review ' + (i + 1) + ' of ' + n;
      }

      function goTo(p, announce) {
        pos = p;
        apply(true);
        setActive((((pos - n) % n) + n) % n, announce);
        if (settleTimer) clearTimeout(settleTimer);
        settleTimer = setTimeout(normalize, reduced() ? 0 : DURATION + 40);
      }

      function step(dir) {
        normalize();
        goTo(pos + dir, true);
      }

      if (prevBtn) prevBtn.addEventListener('click', function () { step(-1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { step(1); });
      dots.forEach(function (d, k) {
        d.addEventListener('click', function () {
          normalize();
          if (k !== current) goTo(n + k, true);
        });
      });

      root.addEventListener('keydown', function (e) {
        var t = e.target;
        if (!t || !t.closest || !t.closest('.ifp-tst-nav')) return;
        if (e.key === 'ArrowLeft') { e.preventDefault(); step(-1); }
        else if (e.key === 'ArrowRight') { e.preventDefault(); step(1); }
      });

      /* swipe / drag */
      var pid = null, startX = 0, startY = 0, tracking = false, dragging = false;
      viewport.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        pid = e.pointerId; startX = e.clientX; startY = e.clientY;
        tracking = true; dragging = false; dragDx = 0;
      });
      viewport.addEventListener('pointermove', function (e) {
        if (!tracking || e.pointerId !== pid) return;
        var dx = e.clientX - startX, dy = e.clientY - startY;
        if (!dragging) {
          if (Math.abs(dx) > 8 && Math.abs(dx) > Math.abs(dy)) {
            dragging = true;
            normalize();
            viewport.classList.add('is-dragging');
            try { viewport.setPointerCapture(pid); } catch (err) { /* ignore */ }
          } else if (Math.abs(dy) > 8) {
            tracking = false;
            return;
          } else {
            return;
          }
        }
        e.preventDefault();
        dragDx = dx;
        apply(false);
      });
      function endDrag(e, cancelled) {
        if (!tracking || e.pointerId !== pid) return;
        tracking = false;
        if (!dragging) return;
        dragging = false;
        viewport.classList.remove('is-dragging');
        try { viewport.releasePointerCapture(pid); } catch (err) { /* ignore */ }
        var dx = dragDx;
        dragDx = 0;
        var threshold = Math.min(60, metrics().sw * 0.15);
        if (!cancelled && dx < -threshold) goTo(pos + 1, true);
        else if (!cancelled && dx > threshold) goTo(pos - 1, true);
        else apply(true);
      }
      viewport.addEventListener('pointerup', function (e) { endDrag(e, false); });
      viewport.addEventListener('pointercancel', function (e) { endDrag(e, true); });
      viewport.addEventListener('dragstart', function (e) { e.preventDefault(); });

      /* keep the active page centred on any size change */
      function relayout() { if (!dragging) { normalize(); apply(false); } }
      if (window.ResizeObserver) {
        new ResizeObserver(relayout).observe(viewport);
      } else {
        window.addEventListener('resize', relayout);
      }
      window.addEventListener('load', relayout);

      setActive(0, false);
      apply(false);
    }
  });

  /* ===== p80-faq ===== */
  /* p80-faq: bottom FAQ accordion. Independent toggles, all closed initially, smooth height (200ms). */
  MODULES.push(function (scope) {
    'use strict';
    var roots = scope.querySelectorAll('[data-ifp-faq]');
    if (!roots.length) return;

    var DURATION = 200;

    function prefersReducedMotion() {
      return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    }

    function initItem(item) {
      var btn = item.querySelector('.ifp-faq-btn[aria-controls]');
      if (!btn) return;
      var panel = item.querySelector('.ifp-faq-panel');
      if (!panel) return;
      var fallback = null;

      function settle() {
        if (fallback) { clearTimeout(fallback); fallback = null; }
        panel.removeEventListener('transitionend', onTransitionEnd);
        var isOpen = btn.getAttribute('aria-expanded') === 'true';
        panel.style.height = '';
        panel.hidden = !isOpen;
      }

      function onTransitionEnd(e) {
        if (e.target === panel && e.propertyName === 'height') settle();
      }

      function setOpen(open) {
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        item.setAttribute('data-state', open ? 'open' : 'closed');
        panel.removeEventListener('transitionend', onTransitionEnd);
        if (fallback) { clearTimeout(fallback); fallback = null; }

        if (prefersReducedMotion()) {
          panel.style.height = '';
          panel.hidden = !open;
          return;
        }

        // Start from the current rendered height so a mid-animation toggle reverses smoothly.
        var from = panel.hidden ? 0 : panel.getBoundingClientRect().height;
        panel.hidden = false;
        panel.style.height = from + 'px';
        void panel.offsetHeight; // commit the start height before changing it
        panel.style.height = (open ? panel.scrollHeight : 0) + 'px';

        panel.addEventListener('transitionend', onTransitionEnd);
        fallback = setTimeout(settle, DURATION + 120); // in case transitionend never fires
      }

      btn.setAttribute('aria-expanded', 'false');
      item.setAttribute('data-state', 'closed');
      panel.hidden = true;

      btn.addEventListener('click', function () {
        setOpen(btn.getAttribute('aria-expanded') !== 'true');
      });
    }

    Array.prototype.forEach.call(roots, function (root) {
      var items = root.querySelectorAll('[data-ifp-faq-item]');
      Array.prototype.forEach.call(items, initItem);
    });
  });

  /* ===== p12-kb-tabs (Shopify only) ===== */
  /* <ifp-kb-tabs> is the buy box's Kaching area. With two app blocks in the section it holds two .ifp-kb-wrap
     children - the one-time widget first, the Subscribe & Save widget second - each with its own copy of the buy
     buttons, and shows one at a time. The switch is the widget's own "Subscribe & Save" row: a click on it is taken
     here (capture phase, trusted clicks only) and never reaches Kaching, so the row works as a tab instead of
     ticking a checkbox. The row of the widget being shown is then set to match what it says: off on the one-time
     widget, on on the subscribe widget. That is also what decides the selling plan, so the cart follows the tab.

     Kaching binds a widget to the form beside it, so only the visible wrap's buttons can add - the same reason
     snippets/kb-buy-buttons.liquid gives each widget its own form on bundle-v21-perfect-widget.

     With a single app block there is one wrap and nothing is intercepted: the row stays Kaching's own checkbox.
     Programmatic clicks (event.isTrusted === false) always pass through, which is how <ifp-buy-now> still un-ticks
     a single widget's subscription before buying. */

  const KB_SWITCH_EVENT = 'ifp:kb-switch';
  const KB_SUBSCRIPTION_ROW = '.kaching-bundles__subscriptions [role="checkbox"]';

  class IfpKbTabs extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;

      this.onCapturedClick = this.onCapturedClick.bind(this);
      this.addEventListener('click', this.onCapturedClick, true);

      /* Kaching renders its widgets after this element exists, so the rows are set as they appear. */
      this.observer = new MutationObserver(() => this.syncRows());
      this.observer.observe(this, { childList: true, subtree: true });
      this.syncRows();
    }

    disconnectedCallback() {
      if (!this.bound) return;
      this.removeEventListener('click', this.onCapturedClick, true);
      if (this.observer) this.observer.disconnect();
      this.bound = false;
    }

    get wraps() {
      return Array.prototype.slice.call(this.querySelectorAll('.ifp-kb-wrap'));
    }

    /** The wrap the customer is looking at (and the only one whose buttons can add). */
    get activeWrap() {
      return this.wraps.filter((wrap) => !wrap.hidden)[0] || null;
    }

    /** Is the Subscribe & Save row a tab switch here, or still Kaching's own checkbox? */
    get isTabbed() {
      return this.wraps.length > 1;
    }

    /** The second wrap is the Subscribe & Save one, so its row reads ticked and the first one's does not. */
    subscribes(wrap) {
      return this.isTabbed && wrap === this.wraps[1];
    }

    onCapturedClick(event) {
      if (!this.isTabbed || !event.isTrusted) return;

      const row = event.target.closest(KB_SUBSCRIPTION_ROW);
      if (!row || !this.contains(row)) return;

      /* the row is the tab control now: Kaching must not also toggle its own checkbox */
      event.preventDefault();
      event.stopImmediatePropagation();

      const wraps = this.wraps;
      const current = wraps.indexOf(row.closest('.ifp-kb-wrap'));
      this.show(wraps[(current + 1) % wraps.length]);
    }

    show(wrap) {
      if (!wrap) return;
      this.wraps.forEach((other) => { other.hidden = other !== wrap; });
      this.syncRows();
      document.dispatchEvent(new CustomEvent(KB_SWITCH_EVENT, { detail: { wrap: wrap } }));
    }

    /** Make each widget's row say what its tab means - and, through Kaching, add with or without a selling plan. */
    syncRows() {
      if (!this.isTabbed) return;

      this.wraps.forEach((wrap) => {
        const row = wrap.querySelector(KB_SUBSCRIPTION_ROW);
        if (!row) return;
        const wanted = this.subscribes(wrap);
        /* this click is not trusted, so it goes to Kaching and not back through onCapturedClick */
        if ((row.getAttribute('aria-checked') === 'true') !== wanted) row.click();
      });
    }
  }

  if (!customElements.get('ifp-kb-tabs')) customElements.define('ifp-kb-tabs', IfpKbTabs);

  /* ===== p16-buy-now (Shopify only) ===== */
  /* <ifp-buy-now> wraps the "Buy it now" button and owns that flow end to end, the way <product-form> owns add to
     cart in assets/product-form-v23.js. A click runs, in order:

       1. the cart is emptied once per page load (/cart/clear.js), so the bundle replaces what was left in the cart
          instead of stacking on top of it. The latch below is the one from product-form-v23.js: the clear happens
          before the add and never after it, because a clear that lands while checkout is loading hands checkout an
          empty cart and bounces the customer back to the storefront (Shopify ticket 69580807).
       2. Kaching's "Subscribe & Save" row is un-ticked, so Kaching prices the deal as a one-time purchase and the
          cart lines it builds carry no selling plan. The row is ticked back if the add never lands, so an error
          never leaves the buy box in a state the customer did not choose.
       3. the theme's own Add to cart button is clicked: product-form.js posts the add and Kaching rewrites it into
          the bundle lines. The cart drawer the theme renders on the way is only a stop here, so <body> carries
          ifp-buynow for the length of the flow and the drawer stays hidden (rule in assets/inflair-pdp.css).
       4. the theme's cart-update event (pubsub.js), or /cart.js polling where the theme has no pubsub, hands over
          to /checkout. A cart error, or the 15s safety timer, resets the button instead.

     Fallback, only if the body class custom_bundle_page were missing on a "for-bundle" URL: the theme's
     product-form.js clears the cart, adds and redirects by itself, so clicking the submit button is all it takes.

     Add to cart is untouched: it still buys whatever is ticked, still opens the drawer, and does not clear. */

  const CART_CLEAR_URL = '/cart/clear.js';
  const BUSY_CLASS = 'ifp-buynow';
  const LOCKED_CLASS = 'ifp-is-locked';   /* Add to cart, while Buy it now owns the cart */
  const SAFETY_MS = 15000;        /* nothing came back: give the button back to the customer */
  const SETTLE_MS = 600;          /* longest wait for Kaching to re-price after the subscription is un-ticked */
  const SETTLE_STEP_MS = 250;     /* gap between the /cart.js reads that confirm the cart has stopped changing */
  const SETTLE_READS = 24;        /* ... and the most reads to take before handing over anyway (~6s) */

  /* The cart may be emptied once per page load, before the first add, and never again afterwards; leaving the page
     means a checkout handoff may be under way, so that closes the latch too. */
  const CartClearLatch = {
    used: false,
    closed: false,
    controller: null,

    /** No clear from here on; abort one that is still in flight. */
    close() {
      this.closed = true;
      if (this.controller) this.controller.abort();
      this.controller = null;
    },

    /** Coming back from the browser cache is a fresh visit: the checkout that closed the latch is over. */
    reopen() {
      this.used = false;
      this.closed = false;
    },

    async run() {
      if (this.used || this.closed) return false;
      this.used = true;
      this.controller = typeof AbortController === 'function' ? new AbortController() : null;

      try {
        const response = await fetch(CART_CLEAR_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          signal: this.controller ? this.controller.signal : undefined,
        });
        return response.ok;
      } catch (err) {
        /* aborted, offline or blocked: the add is still worth attempting */
        return false;
      } finally {
        this.controller = null;
      }
    },
  };

  window.addEventListener('pagehide', function () { CartClearLatch.close(); });
  window.addEventListener('pageshow', function (e) { if (e.persisted) CartClearLatch.reopen(); });

  /* mirrors isKachingPage() in the theme's product-form.js */
  const NO_REDIRECT_BODY = ['custom_bundle_page', 'bundle-sub-v21', 'bundle-sub-v20', 'bundle-sub-v16-dtc', 'bundle-v16', 'bundle-sub-v16'];
  function themeRedirects() {
    for (var i = 0; i < NO_REDIRECT_BODY.length; i++) {
      if (document.body.classList.contains(NO_REDIRECT_BODY[i])) return false;
    }
    var search = window.location.search;
    return search.indexOf('v18') > -1 || search.indexOf('elevate') > -1 || window.location.pathname.indexOf('for-bundle') > -1;
  }
  function rootUrl() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }

  /* assets/global.js arms a flag on any click of an add or checkout button and, when the page is later restored
     from the browser cache, empties the cart (its "pressed back from checkout" fix). On the way to checkout that is
     a clear landing behind the customer: going forward to checkout again finds an empty cart and Shopify sends them
     to the storefront. The flag is dropped on the way out and whenever this page is left, so it is never armed from
     here; other templates keep their own behaviour because global.js is untouched. */
  const BACK_NAV_CLEAR_FLAG = 'cd_pending_cart_clear';
  function dropBackNavClear() {
    try { sessionStorage.removeItem(BACK_NAV_CLEAR_FLAG); } catch (err) { /* storage blocked */ }
  }
  window.addEventListener('pagehide', dropBackNavClear);

  function goCheckout() {
    dropBackNavClear();
    window.location.href = rootUrl() + 'checkout';
  }
  function pubsubEvent(key, fallback) {
    try {
      /* global PUB_SUB_EVENTS (constants.js) */
      if (typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS[key]) return PUB_SUB_EVENTS[key];
    } catch (err) { /* ignore */ }
    return fallback;
  }
  function cartCount() {
    return fetch(rootUrl() + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (res) {
        if (!res.ok) throw new Error('cart.js ' + res.status);
        return res.json();
      })
      .then(function (cart) { return (cart && cart.item_count) || 0; });
  }

  /* Kaching renders its Subscribe & Save row as role="checkbox" and toggles it on click (the app block's widget),
     so this is its own control, not markup of ours: read aria-checked, click to change it. The second selector is
     there for a widget layout that drops the __subscriptions wrapper class; a page with no such row matches neither
     and Buy it now then simply adds whatever is selected. */
  function subscriptionRow(scope) {
    const root = scope || document;
    return root.querySelector('.kaching-bundles__subscriptions [role="checkbox"]')
      || root.querySelector('.kaching-bundles [role="checkbox"]');
  }
  function isSubscribed(el) { return !!el && el.getAttribute('aria-checked') === 'true'; }

  /* Where two Kaching widgets share the buy box, the row is a tab and the widget on screen is the customer's
     choice of one-time or subscribe, so Buy it now buys what they are looking at and un-ticks nothing. */
  function kbTabs() { return document.querySelector('ifp-kb-tabs'); }
  function subscriptionIsChosen() {
    const tabs = kbTabs();
    return !!tabs && tabs.isTabbed;
  }

  class IfpBuyNow extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;

      this.button = this.querySelector('[data-ifp-buynow]');
      if (!this.button) {
        /* upgraded before the parser reached its children: look again once it has */
        if (!this.retried) {
          this.retried = true;
          setTimeout(() => this.connectedCallback(), 0);
        }
        return;
      }

      this.bound = true;
      this.busy = false;
      this.timers = [];
      this.unsubs = [];
      this.unticked = null;      /* the subscription row this click un-ticked, to tick back if the add fails */

      /* a sold-out page ships the button disabled, and nothing here may hand it back */
      this.soldOut = this.button.disabled;

      this.onClick = this.onClick.bind(this);
      this.onPageShow = this.onPageShow.bind(this);
      this.onSubmitClick = this.onSubmitClick.bind(this);
      this.button.addEventListener('click', this.onClick);
      window.addEventListener('pageshow', this.onPageShow);
      document.addEventListener('click', this.onSubmitClick, true);
      this.watchSubmit();
    }

    disconnectedCallback() {
      if (!this.bound) return;
      this.button.removeEventListener('click', this.onClick);
      window.removeEventListener('pageshow', this.onPageShow);
      document.removeEventListener('click', this.onSubmitClick, true);
      if (this.submitObserver) this.submitObserver.disconnect();
      this.cleanup();
      this.bound = false;
    }

    /* -- one button at a time -------------------------------------------- */

    /** The theme marks its Add to cart .loading / aria-disabled while it adds; Buy it now is unavailable until then. */
    watchSubmit() {
      const submit = this.submitButton;
      if (!submit) return;

      this.submitObserver = new MutationObserver(() => this.syncAvailability());
      this.submitObserver.observe(submit, { attributes: true, attributeFilter: ['class', 'aria-disabled', 'disabled'] });
      this.syncAvailability();
    }

    syncAvailability() {
      const submit = this.submitButton;
      const themeIsAdding = !!submit && (submit.classList.contains('loading') || submit.getAttribute('aria-disabled') === 'true');
      /* while this component is the one working it locks Add to cart instead, so it leaves its own button alone */
      this.button.disabled = this.soldOut || (!this.busy && themeIsAdding);
    }

    /** Add to cart is unavailable for as long as Buy it now owns the cart (the click is swallowed either way).
        It is a class and not aria-disabled or disabled, because product-form.js refuses to submit a form whose
        button carries either - and this flow submits that very form. */
    lockSubmit(locked) {
      const submit = this.submitButton;
      if (submit) submit.classList.toggle(LOCKED_CLASS, locked);
    }

    /** While this flow owns the cart, Add to cart beside it would add on top of a cart that is about to be emptied,
        so its click is swallowed - the same guard product-form-v23.js keeps while its own clear is in flight. The
        add this component makes itself is a programmatic click, so it is not trusted and passes through. */
    onSubmitClick(event) {
      if (!this.busy || !event.isTrusted) return;

      const submit = event.target.closest('.product-form__submit');
      const scope = this.closest('.ifp-kb-wrap') || this.closest('product-form');
      if (!submit || !scope || !scope.contains(submit)) return;

      event.preventDefault();
      event.stopImmediatePropagation();
    }

    /* -- the theme's form ------------------------------------------------ */

    get submitButton() {
      const form = this.closest('product-form') || document.querySelector('product-form');
      return form ? form.querySelector('.product-form__submit') : null;
    }

    /* -- button state ---------------------------------------------------- */

    setLoading(on) {
      this.button.classList.toggle('is-loading', on);
      if (on) this.button.setAttribute('aria-busy', 'true');
      else this.button.removeAttribute('aria-busy');
    }

    wait(ms) {
      return new Promise((resolve) => { this.timers.push(setTimeout(resolve, ms)); });
    }

    listen(key, fallback, fn) {
      if (typeof window.subscribe !== 'function') return false;
      const off = window.subscribe(pubsubEvent(key, fallback), fn);
      if (typeof off === 'function') this.unsubs.push(off);
      return true;
    }

    cleanup() {
      this.timers.forEach(clearTimeout);
      this.timers = [];
      this.unsubs.forEach(function (off) { try { off(); } catch (err) { /* ignore */ } });
      this.unsubs = [];
    }

    reset() {
      this.cleanup();
      this.handingOff = false;
      this.busy = false;
      this.setLoading(false);
      this.lockSubmit(false);
      this.syncAvailability();
      document.body.classList.remove(BUSY_CLASS);
      /* the add did not go through, so put the buy box back the way the customer left it */
      if (this.unticked && !isSubscribed(this.unticked)) this.unticked.click();
      this.unticked = null;
      this.closeDrawer();
    }

    /** Coming back via the browser back button (bfcache) must not leave a spinner, or a hidden drawer, behind. */
    onPageShow(event) {
      if (event.persisted) this.reset();
    }

    closeDrawer() {
      const drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.close === 'function') {
        try { drawer.close(); } catch (err) { /* ignore */ }
      }
    }

    /* -- the flow -------------------------------------------------------- */

    async onClick() {
      const submit = this.submitButton;
      if (this.busy || !submit || submit.disabled || submit.getAttribute('aria-disabled') === 'true') return;

      this.busy = true;
      this.setLoading(true);
      this.lockSubmit(true);
      document.body.classList.add(BUSY_CLASS);
      this.timers.push(setTimeout(() => this.reset(), SAFETY_MS));
      this.listen('cartError', 'cart-error', () => this.reset());

      await this.dropSubscription();
      await CartClearLatch.run();
      /* closed before the add, not after: from here Kaching may add and checkout may start at any moment, and no
         clear of ours is allowed to overtake that navigation */
      CartClearLatch.close();

      /* the theme editor can re-render the form while the clear is in flight */
      const button = this.submitButton;
      if (!button) return this.reset();
      this.addAndCheckout(button);
    }

    /** Un-tick Subscribe & Save, then give Kaching a moment to re-price the deal before the add reads it. */
    async dropSubscription() {
      if (subscriptionIsChosen()) return;   /* the visible widget already is the choice; see kbTabs() above */

      const row = subscriptionRow(this.closest('.ifp-kb-wrap'));
      if (!isSubscribed(row)) return;

      this.unticked = row;
      row.click();
      for (let waited = 0; waited < SETTLE_MS && isSubscribed(row); waited += 50) await this.wait(50);
      await this.wait(60);
    }

    addAndCheckout(submit) {
      if (themeRedirects()) {
        submit.click();
        return;
      }
      if (this.listen('cartUpdate', 'cart-update', () => this.handOff())) {
        submit.click();
        return;
      }

      /* no pubsub on this theme: watch /cart.js for the new items */
      let tries = 0;
      cartCount().then(null, function () { return -1; }).then((before) => {
        submit.click();
        const poll = () => {
          this.timers.push(setTimeout(() => {
            cartCount().then((count) => {
              if (before >= 0 ? count > before : count > 0) this.handOff();
              else if (++tries < 20) poll();
              else this.reset();
            }, () => {
              if (++tries < 20) poll();
              else this.reset();
            });
          }, 500));
        };
        poll();
      });
    }

    /**
     * The theme's cart-update only says the theme's own add came back. Kaching sends its bundle add beside it, so
     * the cart can still be changing at that moment, and a checkout that loads over a cart still being written is
     * what bounces the customer back to the storefront - the failure assets/product-form-v23.js avoids by never
     * forcing the navigation at all. Buy it now does need it, so it waits for /cart.js to hold still first.
     */
    async handOff() {
      if (this.handingOff) return;
      this.handingOff = true;
      this.cleanup();                  /* no safety reset while we wait: this click is committed now */

      await this.waitForSettledCart();
      goCheckout();
    }

    /** Two reads of /cart.js in a row with the same non-zero count: nothing is in flight any more. */
    async waitForSettledCart() {
      let previous = -1;

      for (let i = 0; i < SETTLE_READS; i++) {
        const count = await cartCount().then(null, function () { return -1; });
        if (count > 0 && count === previous) return true;
        previous = count;
        await this.wait(SETTLE_STEP_MS);
      }
      return previous > 0;
    }
  }

  if (!customElements.get('ifp-buy-now')) customElements.define('ifp-buy-now', IfpBuyNow);

  function boot(scope) {
    MODULES.forEach(function (run) {
      try {
        run(scope);
      } catch (err) {
        if (window.console && console.error) console.error('[inflair-pdp]', err);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  /* Theme editor: a re-rendered section is new markup, so wire it up again */
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target;
    if (el && el.querySelector && el.querySelector('.ifp')) boot(el);
  });
})();
